import { render, staticRenderFns } from "./PostExcerpt.vue?vue&type=template&id=7def1bc1&scoped=true&lang=pug&"
import script from "./PostExcerpt.vue?vue&type=script&lang=js&"
export * from "./PostExcerpt.vue?vue&type=script&lang=js&"
import style0 from "./PostExcerpt.vue?vue&type=style&index=0&id=7def1bc1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def1bc1",
  null
  
)

export default component.exports